import React from 'react'
import { BreadcrumbJsonLd } from 'next-seo'

const BreadcrumbsStructuredDataSEO = ({ breadCrumbsStructuredData }) => (
  <BreadcrumbJsonLd itemListElements={breadCrumbsStructuredData} />
)

export default BreadcrumbsStructuredDataSEO
